jQuery( '.burgerBun' ).click( function() {
  jQuery( '.burgerBun' ).toggleClass( "open" );
  jQuery( '.menu-mobile-menu-container' ).toggleClass( "open" );
} );
jQuery( '.menu-mobile-menu-container a' ).click( function() {
  jQuery( '.burgerBun' ).removeClass( "open" );
  jQuery( '.menu-mobile-menu-container' ).removeClass( "open" );
} );

const siteHeader = document.querySelector( '#site-header' );
window.addEventListener( 'scroll', setHeaderState, { passive: true } );
window.addEventListener( 'resize', setHeaderState, { passive: true } );

function setHeaderState() {
  if ( jQuery( document ).scrollTop() > 5 ) {
    siteHeader.dataset.scrolled = 'true';
  } else {
    siteHeader.dataset.scrolled = 'false';
  }
}